module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.5 6.3l-7.65-4.35v8.7zm-13.35 0L4.5 1.95v8.7z","fill":"#39b54a"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/double_arrows.svg
// module id = 702
// module chunks = 2